import {
  Fetcher,
  FetchImplementation,
  HttpResource,
  Link,
  Resource,
} from "@readium/shared";

import { WPSClient } from "./client";
import { HtmlResource } from "./HtmlResource";

export class WPSClientFetcher implements Fetcher {
  constructor(private readonly client: WPSClient) {}

  links(): Link[] {
    return [];
  }
  get(link: Link): Resource {
    const fetch: FetchImplementation = this.client.fetchResource.bind(
      this.client
    );

    if (link.mediaType.isHTML) {
      return new HtmlResource(
        fetch,
        link,
        // let the fetch client handle the base URL
        link.toURL("/")
      );
    }

    return new HttpResource(
      fetch,
      link,
      // let the fetch client handle the base URL
      link.toURL("/")
    );
  }
  close(): void {
    // no-op
  }
}
